import React, { useEffect, useRef } from 'react';
import { Button, Input, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import { useState } from "react";
import { actionBeneficiary, APICouponCode, paymentRequestAction } from "../handler/accountHandler"
import UserLoader from '../Dashboard/UserLoader';
import { getAdminPannel } from '../handler/LoginAndSingupHandler';



const CouponCode = () => {
    const isRun = useRef(false);
    type packagePayment = {
        couponCodeId: number,
        couponCodeName: string,
        couponCode: string,
    };
    const packagePayments = [{
        couponCodeId: 0,
        couponCodeName: "",
        couponCode: "",
    }];
    const [packagePaymentDetail, setPackagePaymentDetail] = useState([{
        couponCodeId: 0,
        couponCodeName: "",
        couponCode: "",
    }]);
    const [showBeneficiaryModule, setBeneficiaryModule] = useState(false);
    const getPackagePayment = async () => {
        setLoader(true);
        var response = await APICouponCode({
            "couponCodeRequest": 1,
            "couponCodeId": 0,
            "couponCodeName": "string",
            "couponCode": "string"
        });
        if (response.statusCode === 200) {
            
            const packageRequest = response.data.couponCodes;
            setPackagePaymentDetail(packageRequest);
        }
        setLoader(false);
    }
    useEffect(() => {
        if (isRun.current === false) {
            getPackagePayment();
            isRun.current = true;
        }
    }, [isRun])
    const [addCourseData, setAddCourseData] = useState({
        couponCodeId: 0,
        couponCodeName: "",
        couponCode: "",
    })
    const handelOnChange = (name: string, e: any) => {
        const value = e.target.value;
        setAddCourseData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };
    const addCourse = async () => {
        
        setLoader(true);
        var response = await APICouponCode({
            "couponCodeRequest": 2,
            "couponCodeName": addCourseData.couponCodeName,
            "couponCode": addCourseData.couponCode
        });
        if (response.statusCode === 200) {
            
            const packageRequest = response.data.couponCodes;
            setPackagePaymentDetail(packageRequest);
        }
        setLoader(false);
    };

    const deleteCourse = async (CouponId:number) => {
        
        setLoader(true);
        var response = await APICouponCode({
            "couponCodeRequest": 4,
            "couponCodeId": CouponId,
        });
        if (response.statusCode === 200) {
            
            const packageRequest = response.data.couponCodes;
            setPackagePaymentDetail(packageRequest);
        }
        setLoader(false);
    };
    const [pendingRequest, setPendingRequest] = useState(packagePayments);
    const [succesfullRequest, setSuccesfullRequest] = useState(packagePayments);
    const [succesfullRequestToShow, setSuccesfullRequestToShow] = useState(packagePayments);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loader, setLoader] = useState(false);
    return (
        <>
            <section className='headerBackground'>
                {loader && (
                    <UserLoader />
                )}
                {!loader && (
                    <>
                        {
                            packagePaymentDetail.length > 0 &&
                            <div className='space-ptb achievers-section headerBackground' style={{ borderStyle: "inset", borderColor: "white", padding: "30px" }}>
                            <TableContainer style={{ background: "white" }}>
                                <h3 style={{ textAlign: "center" }}>Coupon Code</h3>
                                <Table>
                                    <TableHead>
                                        <TableRow >
                                            <TableCell align="center">CouponId</TableCell>
                                            <TableCell align="center">CouponName</TableCell>
                                            <TableCell align="center">CodeCoupon</TableCell>
                                            <TableCell align="center">Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {packagePaymentDetail.map((data, index) => (
                                            <>
                                                <TableRow>
                                                    <TableCell align="center">{data.couponCodeId}</TableCell>
                                                    <TableCell align="center">{data.couponCodeName}</TableCell>
                                                    <TableCell align="center">{data.couponCode}</TableCell>
                                                    <TableCell align="center">
                                                        <Button style={{ color: "red" }} onClick={()=>{deleteCourse(data.couponCodeId)}}>Delete</Button>
                                                    </TableCell>
                                                </TableRow>
                                            </>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                        }
                        <div style={{ display: "flex", justifyContent: "center", marginTop: "2rem" }}>
                            <TableContainer
                                style={{
                                    background: "white",
                                    padding: "1.5rem",
                                    borderRadius: "10px",
                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                    width: "fit-content",
                                }}
                            >
                                <h3 style={{
                                    textAlign: "center",
                                    marginBottom: "1rem",
                                    fontFamily: "Segoe UI, sans-serif",
                                    fontWeight: 500,
                                    fontSize: "1.4rem",
                                    color: "#333"
                                }}>
                                    Add a New Coupon
                                </h3>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Coupon Name</TableCell>
                                            <TableCell align="center"><Input placeholder="Enter name" onChange={(e) => { handelOnChange("couponCodeName", e) }} /></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="center">Coupon Code</TableCell>
                                            <TableCell align="center"><Input placeholder="Enter Code" onChange={(e) => { handelOnChange("couponCode", e) }} /></TableCell>
                                        </TableRow>
                                    </TableHead>
                                </Table>
                                <div style={{ display: "flex", justifyContent: "center", marginTop: "1.5rem" }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{
                                            padding: "0.6rem 2rem",
                                            fontWeight: "bold",
                                            transition: "transform 0.2s",
                                        }}
                                        disabled={!addCourseData.couponCode}
                                        onClick={() => { addCourse() }}
                                        onMouseOver={e => e.currentTarget.style.transform = "scale(1.05)"}
                                        onMouseOut={e => e.currentTarget.style.transform = "scale(1)"}
                                    >
                                        Add
                                    </Button>
                                </div>
                            </TableContainer>
                        </div>
                    </>
                )}
            </section>
        </>
    );
};

export default CouponCode;
